// extracted by mini-css-extract-plugin
module.exports = {"ctn":"MercadoPago_ctn__1gR5J"};